module.exports = __webpack_public_path__ + "img/alert-octagon.6f55e6eb.svg";